module.exports = __webpack_public_path__ + "img/acct.f142aa42.png";